import React from 'react'
import AllAccountMappingDetails from './AllAccountMappingDetails'

const AccountMapperNew = (props) => {
  return (
    <div className="account-mapper">
      <AllAccountMappingDetails {...props} />
    </div>
  )
}

export default AccountMapperNew
